import { render, staticRenderFns } from "./AdminLoginView.vue?vue&type=template&id=c0fa4526&scoped=true&"
import script from "./AdminLoginView.vue?vue&type=script&lang=js&"
export * from "./AdminLoginView.vue?vue&type=script&lang=js&"
import style0 from "./AdminLoginView.vue?vue&type=style&index=0&id=c0fa4526&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0fa4526",
  null
  
)

export default component.exports